import { render } from "./Faq.vue?vue&type=template&id=3cf2b226"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/251623126/emo-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__